import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { motion } from "framer-motion";
import UserMenu from "./UserMenu";
interface HeaderProps {
  children: React.ReactNode;
}

export default function Header({ children }: HeaderProps) {
  const { user } = useAuth();
  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <motion.div
        className="flex items-center justify-between"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        {/* Parte izquierda: contenido personalizado */}
        <div>{children}</div>

        {/* Parte derecha: fija */}
        <div className="flex items-center space-x-4">
          {/* Usuario */}
          <div className="flex items-center space-x-3">
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">
                {user?.fullName}
              </p>
              <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
            </div>
            <motion.div
              className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center shadow-sm"
              animate={{ y: [0, -2, 0, 2, 0] }}
              transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
              whileHover={{ scale: 1.05 }}
              style={{ willChange: "transform" }}
            >
              <UserMenu />
            </motion.div>
          </div>
        </div>
      </motion.div>
    </header>
  );
}
